import { render } from "./AnnualPlan.vue?vue&type=template&id=2dd1d476&scoped=true"
import script from "./AnnualPlan.vue?vue&type=script&lang=js"
export * from "./AnnualPlan.vue?vue&type=script&lang=js"

import "./AnnualPlan.vue?vue&type=style&index=0&id=2dd1d476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd1d476"]])

export default __exports__